import React, { useState } from "react";
import Modal from "../components/dumb/Modal";

// Each modal should have its own hook
const useModal = (closable = true) => {
  const [isVisible, setIsVisible] = useState(false);
  
  const event = {
    onHide:() => {},
    onShow:() => {}
  };

  const show = () => {setIsVisible(true); event.onShow()};
  const hide = () => {setIsVisible(false); event.onHide()};
  
  const renderModal = (children, additionalProps = {}) => (
    <React.Fragment>
      {isVisible && <Modal closeModal={hide} {...additionalProps} closable={closable}>{children}</Modal>}
    </React.Fragment>
  );

  return [
    show,
    hide,
    renderModal,
    event
  ];
}

export default useModal;